export default function DestinationTypeSelectionController(DestinationService, countryService, UtilService, DESTINATION_TYPES) {
  const vm = this;

  vm.destinationType = null;
  vm.countryId = null;
  vm.regionId = null;
  vm.cityId = null;
  vm.parentId = null;
  vm.districtId = null;
  vm.destinationTypes = DESTINATION_TYPES;

  vm.options = {
    countries: [],
    regions: [],
    cities: [],
    districts: [],
    destinationTypes: [
      DESTINATION_TYPES.REGION.name,
      DESTINATION_TYPES.CITY.name,
      DESTINATION_TYPES.DISTRICT.name,
      DESTINATION_TYPES.POI.name,
    ],
  };

  vm.init = init;
  vm.getCountries = getCountries;
  vm.getRegions = getRegions;
  vm.getCities = getCities;
  vm.getDistricts = getDistricts;
  vm.resetParentOptions = resetParentOptions;
  vm.updateParentId = updateParentId;

  init();

  function init() {
    vm.getCountries();
  }

  function getCountries() {
    countryService.getAllCountries().then(res => {
      if (res && res.data) {
        vm.options.countries = res.data;
      }
    });
  }

  function getRegions() {
    let params;
    if (!vm.countryId) {
      return;
    }
    params = UtilService.generateSearchUrl({ destination_type: 'region' });
    DestinationService.getDestinationChildren(vm.countryId, params).then(res => {
      vm.options.regions = res.data;
      vm.options.cities = [];
    });
  }

  function getCities() {
    let params;
    if (!vm.regionId) {
      return;
    }
    params = UtilService.generateSearchUrl({ destination_type: 'city' });
    DestinationService.getDestinationChildren(vm.regionId, params).then(res => {
      vm.options.cities = res.data;
    });
  }

  function getDistricts() {
    let params;
    if (!vm.cityId) {
      return;
    }
    params = UtilService.generateSearchUrl({ destination_type: 'district' });
    DestinationService.getDestinationChildren(vm.cityId, params).then(res => {
      vm.options.districts = res.data;
    });
  }

  function resetParentOptions() {
    vm.countryId = null;
    vm.options.regions = [];
    vm.options.cities = [];
  }

  function updateParentId() {
    switch (vm.destinationType) {
      case 'region':
        vm.parentId = vm.countryId;
        break;
      case 'city':
        vm.parentId = vm.regionId;
        break;
      case 'district':
        vm.parentId = vm.cityId;
        break;
      case 'poi':
        vm.parentId = vm.districtId;
        break;
      default:
        vm.parentId = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/destinations/destination-type-selection.controller.js